module.exports = __webpack_public_path__ + "static/media/leadlearning.07d4a306.jpg";